import { Box, HStack, Spinner, Text } from 'native-base';
import React from 'react';
import { RegistrationStatus } from '../../constants/Registration';
import { useAppSelector } from '../../store';
import { colors } from '../../styles';

export const PendingRegistrationBanner: React.FC = () => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  if (!currentUser) {
    return null;
  }

  if (currentUser.registration?.status !== RegistrationStatus.PENDING) {
    return null;
  }

  return (
    <Box backgroundColor={colors.warningLight} borderRadius={8} p={4} mb={4}>
      <HStack alignItems="center" space={3}>
        <Spinner size="sm" color={colors.warning} />
        <Box flex={1}>
          <Text fontWeight="bold" color={colors.black} mb={1}>
            Setting up your account...
          </Text>
          <Text fontSize="sm" color={colors.darkGrey}>
            This usually takes a few minutes. Pull down to refresh.
          </Text>
        </Box>
      </HStack>
    </Box>
  );
};
